import { Component } from '@angular/core';
import { vendorLogin } from './vendor-login.model';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../shared/auth/auth-service';
import { StorageService } from '../shared/auth/storage-service';
import { LoginService } from '../shared/services/login-service';
import { VendorLoginService } from '../shared/services/vendor-login.service';

@Component({
  selector: 'app-vendor-login',
  templateUrl: './vendor-login.component.html',
  styleUrls: ['./vendor-login.component.scss']
})
export class VendorLoginComponent {
  login: vendorLogin = new vendorLogin();
  show_button: Boolean = false;
  show_eye: Boolean = false;
  constructor(
    private toastr: ToastrService,
    private vendorLogInServices: VendorLoginService,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService
  ) {
    if (this.authService.isLoggedIn()) {
      this.router.navigateByUrl('/vendor/dashboard')
    }
  }

  showPassword() {
    this.show_button = !this.show_button;
    this.show_eye = !this.show_eye;
  }

  loginUser() {
    this.vendorLogInServices.userLogin(this.login).subscribe((res: any) => {
      if (res && res.body && res.status == 200) {
        const token = res.body.response.token;
        this.authService.setToken(token);
        this.authService.setAuthTokenInCookie(token);
        this.storageService.saveUser(res.body.response);
        this.toastr.success(res.body.message);
        this.router.navigateByUrl('/vendor/dashboard');
        const authToken = this.authService.getAuthTokenFromCookie();
      };
    }, (err: any) => {
      if (err.error && err.error.error) {
        this.toastr.error(err.error.error);
      } else {
        this.toastr.error(err.error.message);
      }
      console.error('Login error:', err);
    })
  }
  loginAdmin() {
    this.router.navigateByUrl('/login')
  }
}
